import {Promise} from 'es6-promise';
import fetch from 'isomorphic-fetch';

export const ORIGIN_KEY = "origins";
export const DESTINATION_KEY = "destinations";

var buildCodes = function(stations) {
  return _.map(stations, x => x.code).join(',');
};

export function stationSearch(query, include_pseudo_cities, suggestedStations, selectedOrigins, selectedDestinations) {
  let endpoint = `/station_autocomplete/?query=${encodeURI(query)}`;

  if (include_pseudo_cities === true) {
    endpoint += '&pseudo_cities=true';
  }

  if (suggestedStations) {
    endpoint += '&suggested_stations=' + suggestedStations;
  }

  if (selectedOrigins) {
    endpoint += '&selected_origin_codes=' + buildCodes(selectedOrigins);
  }

  if (selectedDestinations) {
    endpoint += '&selected_destination_codes=' + buildCodes(selectedDestinations);
  }

  return fetch(endpoint, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then((response) => {
      if (response.status >= 400) {
        throw new Error("Bad response from server");
      }
      return response.json();
    });
}